import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import HomeServices from './components/HomeServices';
import HomeCaseStudy from './components/HomeCaseStudy';
import HomeFAQ from './components/HomeFAQ';
import HomeContact from './components/HomeContact';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://grainn-office.com';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: `${siteUrl}/`,
      name: 'GRAINN｜大阪 WEBサイト制作・SNS運用代行・MEO対策',
      description: 'WEBサイト制作・SNS運用代行・MEO対策——ひとりの代表が一気通貫で伴走します。大阪を拠点に、全国対応可能です。',
      inLanguage: 'ja',
    },
    {
      '@type': ['LocalBusiness', 'ProfessionalService'],
      '@id': `${siteUrl}/#business`,
      name: 'GRAINN',
      url: `${siteUrl}/`,
      description: 'WEBサイト制作・SNS運用代行・MEO対策——ひとりの代表が一気通貫で伴走します。大阪を拠点に、全国対応可能です。',
      telephone: '080-5353-0610',
      email: 'goto_sn@grain-n.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '福島区福島',
        addressLocality: '大阪市',
        addressRegion: '大阪府',
        addressCountry: 'JP',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 34.695,
        longitude: 135.484,
      },
      areaServed: '大阪府',
      founder: {
        '@type': 'Person',
        '@id': `${siteUrl}/#person`,
        name: '後藤慎吾',
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '料金はどのくらいかかりますか？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'WEBサイト制作はランディングページ ¥50,000〜、コーポレートサイト ¥150,000〜 が目安です。SNS運用代行は月額 ¥19,800〜、MEO・SEO対策は月額 ¥20,000〜 から対応可能です。',
          },
        },
        {
          '@type': 'Question',
          name: '制作期間はどのくらいかかりますか？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'ランディングページで最短3〜5日、コーポレートサイトで1〜2週間が目安です。AIを活用した制作フローにより、従来よりも大幅にスピードアップを実現しています。',
          },
        },
        {
          '@type': 'Question',
          name: '大阪以外でも対応できますか？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'はい、全国どこでもオンラインで対応しています。ヒアリングから納品まですべてリモートで完結できます。',
          },
        },
        {
          '@type': 'Question',
          name: '制作後のサポートはありますか？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '月額 ¥5,000〜 の保守プランをご用意しています。セキュリティ対応・テキスト修正・プラグイン更新など、公開後も安心してお任せいただけます。',
          },
        },
        {
          '@type': 'Question',
          name: '複数のサービスをまとめてお願いできますか？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'もちろん可能です。WEBサイト制作＋SNS運用代行＋MEO対策など、複数サービスを組み合わせてご依頼いただく場合は、トータルでご支援プランを組むことができます。',
          },
        },
        {
          '@type': 'Question',
          name: '予算が少ないのですが相談できますか？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'はい、ぜひご相談ください。ご予算と優先度をヒアリングしたうえで、最適なプランを一緒に考えます。段階的に進めることも可能です。',
          },
        },
      ],
    },
  ],
};

export default function HomePage() {
  return (
    <main className="min-h-screen">
      <title>大阪 WEBサイト制作・SNS運用代行・MEO対策 GRAINN｜後藤慎吾 代表</title>
      <meta name="description" content="WEBサイト制作・SNS運用代行・MEO対策——ひとりの代表が一気通貫で伴走します。大阪を拠点に、全国対応可能です。" />
      <meta name="keywords" content="大阪,WEBサイト制作,後藤慎吾,GRAINN,MEO対策,ホームページ作成" />
      <link rel="canonical" href={`${siteUrl}/`} />
      <JsonLd data={homeJsonLd} id="home" />
      <Navbar />
      <Hero />
      <HomeServices />
      <HomeCaseStudy />
      <HomeFAQ />
      <HomeContact />
      <Footer />
    </main>
  );
}
